import { gql } from "apollo-boost"

export const deleteComments = gql`
  mutation DeleteComments($data: [ID!]!){
    DeleteComments(data: $data)
  }
`
